import addSchedulePointTemplate from './../../settings/add-schedule-point/add-schedule-point.html';
import './schedule-points.scss';
import template from './schedule-points.html';

class SchedulePointsComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    SchedulePointService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.SchedulePointService = SchedulePointService;
    this.schedulePoints = [];
    this.columnKeys = ['startTime', 'endTime', 'activities'];
  }

  $onInit() {
    this.getAllSchedulePoints();
    if (this.me.roleName === 'MANAGER') {
      this.columnKeys.push('id');
    }
  }

  $onChanges(changes) {
    if (changes.me) {
      this.me = {...this.me};
    }
  }

  addSchedulePoint(ev) {
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'AddSchedulePointController',
      template: addSchedulePointTemplate,
      clickOutsideToClose: true,
      targetEvent: ev,
      multiple: true
    })
      .then(() => {
        this.getAllSchedulePoints();
      }, () => {});
  }

  getAllSchedulePoints() {
    this.SchedulePointService.getAll(true).then(result => {
      this.schedulePoints = result;
    })
      .catch(() => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Nie udało się pobrać planu zajęć')
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }

  removeSchedulePoint(schedulePointId, ev) {
    ev.stopPropagation();
    this.SchedulePointService.delete(schedulePointId).then(() => {
      this.$mdToast.show(
        this.$mdToast.simple()
          .textContent('Pomyślnie usunięto element')
          .position('bottom right')
          .hideDelay(3000)
      );
    })
      .catch(({MessagePL}) => {
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent(MessagePL)
            .position('bottom right')
            .hideDelay(3000)
        );
      });
  }
}

export const SchedulePoints = {
  bindings: {
    me: '<'
  },
  template,
  controller: SchedulePointsComponent
};
